<div class="access-denied-container">
  You do not have permission to view this task. Contact an admin to assign the
  proper user role to your account.
</div>
